import type { Recommendation, Source } from '../api/types';

/**
 * Where a ticket's 詳細 button goes. A rider who signed in with MyAnimeList
 * gets the MAL page; everyone else, and any title MAL has no entry for, gets
 * AniList. The label always names the site the link actually opens.
 */
export function titleLink(rec: Recommendation, source: Source) {
  if (source === 'mal' && rec.mal_id) {
    return { href: `https://myanimelist.net/anime/${rec.mal_id}`, label: 'MYANIMELIST' };
  }
  // site_url is relayed from AniList's metadata; only a web link may become an href.
  const site = rec.site_url && /^https:\/\//i.test(rec.site_url) ? rec.site_url : null;
  return { href: site ?? `https://anilist.co/anime/${rec.media_id}`, label: 'ANILIST' };
}
